import React, { useState } from 'react';
import { Container, Card, Form, Button, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaUserGraduate, FaArrowLeft } from 'react-icons/fa';
import axios from '../api/axios'; // Your custom axios instance
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function StudentLogin() {
  // 1. State management for form inputs, loading, and errors
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // 2. Function to handle form submission
  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

  
    const payload = {
      username: loginId,
      password: btoa(password), 
      loginType: "student"
    };

    try {
      const response = await axios.post(`${BASE_URL}/login/doLogin`,payload);

      // Check for a successful status from your API
      if (response.data && response.data.status === '1') {
        const userDetails = response.data.userdetails?.[0];
        const token = userDetails?.token;

        if (token) {
          toast.success("Login Successful!");
          
          // 4. Set the cookies for authentication
          Cookies.set('token', token, { expires: 1 }); 
          Cookies.set('userRole', 'student', { expires: 1 });
          localStorage.setItem('user', JSON.stringify(userDetails));

          // 5. Redirect to the main student area (which will likely resolve to the dashboard)
          navigate('/student');
        } else {
          throw new Error("Login successful, but no token was provided.");
        }
      } else {
        // Handle login failure from the API
        const errorMessage = response.data.message || "Invalid credentials.";
        setError(errorMessage);
        toast.error(errorMessage);
      }
    } catch (err) {
      console.error("Login API call failed:", err);
      const errorMessage = err.response?.data?.message || "An error occurred. Please try again.";
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' 
      }}>
        <Container style={{ maxWidth: '450px' }}>
          <Card className="shadow-lg border-0 rounded-3">
            <Card.Body className="p-5">
              <div className="text-center mb-4">
                <div style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  background: 'var(--accent-gradient, linear-gradient(135deg, #2563eb, #7c3aed))',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 1rem'
                }}>
                  <FaUserGraduate size={40} />
                </div>
                <h2 className="fw-bold">Student Portal</h2>
                <p className="text-muted">Sign in to access your dashboard.</p>
              </div>
              
              {/* 6. Wire up the form to the handleSubmit function */}
              <Form onSubmit={handleLogin}>
                {error && <p className="text-danger text-center small">{error}</p>}
                
                <Form.Group className="mb-3" controlId="studentId">
                  <Form.Label>Student ID or Email</Form.Label>
                  <Form.Control 
                    type="text" 
                    placeholder="Enter your ID or email" 
                    required 
                    value={loginId}
                    onChange={(e) => setLoginId(e.target.value)}
                    disabled={isLoading}
                  />
                </Form.Group>

                <Form.Group className="mb-4" controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control 
                    type="password" 
                    placeholder="Enter your password" 
                    required 
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isLoading}
                  />
                </Form.Group>

                <Button 
                  variant="primary" 
                  type="submit" 
                  className="w-100 btn-primary"
                  size="lg"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                      Logging in...
                    </>
                  ) : (
                    'Login'
                  )}
                </Button>
                
                <div className="text-center mt-4">
                  <Link to="/" className="text-muted text-decoration-none">
                    <FaArrowLeft size={12} className="me-2" />
                    Back to Home
                  </Link>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </div>
  );
};